import { render, staticRenderFns } from "./wave-bottom.vue?vue&type=template&id=584baad3&"
import script from "./wave-bottom.vue?vue&type=script&lang=js&"
export * from "./wave-bottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports